
let Courses = [
   
  {
    title: "Design Thinking",
    instructor: "Profa. Dra. Genilda da Silva Alexandria Sousa",
    institution: "PUC Goiás",
    desc: ``,
    date: "17/10",
    time: "19:30",
    place: "Presencial: Auditório III Área II",
    //link: ""
  }, 
  {
    title: "Minicurso Sobre Github",
    instructor: "Milton de Assis Ribeiro Neto",
    institution: "PUC Goiás",
    desc: ``,
    date: "18/10",
    time: "15:00",
    place: 'Microsoft Teams.',
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NDE4YWQ0YTQtMzU0Yy00YTcxLTljYzUtYjRmMWVjMjM1NGZl%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2240bb2b05-1841-4e71-946d-794d726cf0cb%22%7d"
    
  },

  {
    title: "Prototipação para Hackathons",
    instructor: 'Prof. Me. Rafael Leal Martins',
    institution: 'PUC Goiás.',
    desc: ``,
    date: '18/10',
    time: '16:00',
    place: 'Microsoft Teams',
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_MmM5NzZlNWYtMTAwZC00ZWIwLWE5YTAtZmE4N2QwMTRjMTMz%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2240bb2b05-1841-4e71-946d-794d726cf0cb%22%7d"
  
  },

  {
    title: "Criando Protótipos com Figma",
    instructor: 'Tayná Rodrigues de Sousa Carvalho',
    institution: 'PUC Goiás',
    desc: ``,
    date: '18/10',
    time: '17:00',
    place: 'Microsoft Teams',
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_ZTBiODc4NDItOWRlNS00NWNiLWJhM2EtMGJmNjA1YzcwMGUx%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2240bb2b05-1841-4e71-946d-794d726cf0cb%22%7d"
  
  },
  
  {
    title: "HTML - a crash course - Cancelado",
    instructor: 'Hiagho Junio Gomes Oliveira',
    institution: 'PUC Goiás',
    desc: ``,
    date: '18/10',
    time: '19:30',
    place: 'Cancelado',    
    //link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_ODc2MDZlNDQtMjRhMS00NjI0LTg2NjctYTgyMDNjMTBjOGJj%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2240bb2b05-1841-4e71-946d-794d726cf0cb%22%7d"
  },

  {
    title: "Docker na Prática: Criando e Gerenciando Contêineres " +
           "para Desenvolvimento e Produção",
    instructor: 'Prof. Me. Daniel Correa da Silva',
    institution: 'PUC Goiás',
    desc: ``,
    date: '19/10',
    time: '09:00',
    place: 'Microsoft Teams',
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NDg1ZWI1ZWUtZTEzYy00NWEyLWEyNmQtMmU1MmIxMzk5YWQ0%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2240bb2b05-1841-4e71-946d-794d726cf0cb%22%7d"
  },
  
  {
    title: "Pitch - técnicas de uma apresentação campeã",
    instructor: 'Profa. Me. Lucilia Gomes Ribeiro',
    institution: 'PUC Goiás',
    desc: ``,
    date: '19/10',
    time: '11:00',
    place: 'Microsoft Teams',
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NjdkOGY0MzQtNzkzNi00MzhkLWIxZWItMzQ4YThiNTM1OGZk%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2240bb2b05-1841-4e71-946d-794d726cf0cb%22%7d"
  },

  {
    title: "Exercícios de Relaxamento para um bom Pitch",
    instructor: 'Profa. Me. Luri Sabina Cosme da Silva Matos',
    institution: 'PUC Goiás',
    desc: ``,
    date: '19/10',
    time: '17:30',
    place: 'Presencial: Auditório III Área II',
    //link: ""
  },
  {
    title: "Evoluindo na TI: Enxergando além dos computadores",
    instructor: 'Iuri Cesar Caliman',
    institution: 'PUC Goiás',
    desc: ``,
    date: '18/10',
    time: '19:30',
    place: 'Microsoft Teams',
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_OTZiODJmMjQtNTlmMy00NTA0LWJlNmEtMDMwMTI3ZTc5ZDk0%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d "
  },
]

/*
const Courses_Civil = [
]

const Courses_Computacao = [
  


]

const Courses_Producao = [
  
]

const Courses_Caer = [
  
]

*/
Courses = Courses.sort((a, b) => {
  if(a.date < b.date) return -1;
  if(a.date > b.date) return 1;
  if(a.time < b.time) return -1;
  if(a.time > b.time) return 1;
  if(a.title < b.title) return -1;
  if(a.title > b.title) return 1;
  return 0;
});

export const miniCourses_Section = [
  {
    curso: "Agronomia",
    minicurso: Courses,
  },
  /*
  {
    curso: 'Ciências Aeronáuticas',
    minicurso: Courses_Caer
  },
  {
    curso: "Civil",
    minicurso: Courses_Civil
  },
  {
    curso: "Computacao",
    minicurso: Courses_Computacao
  },
  {
    curso: "Producao",
    minicurso: Courses_Producao
  },
  */
]